import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';

try {
  const root = document.getElementById('root');
  if (!root) throw new Error('Root element not found');

  createRoot(root).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  );
} catch (error) {
  console.error('Error initializing app:', error);

  // Fallback error display
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100vh; padding: 20px; text-align: center; background: linear-gradient(to bottom right, #f9fafb, #eff6ff);">
        <div style="max-width: 500px;">
          <h1 style="font-size: 24px; font-weight: bold; color: #1f2937; margin-bottom: 16px;">Erreur de chargement</h1>
          <p style="color: #6b7280; margin-bottom: 24px;">Une erreur s'est produite lors du chargement de l'application. Veuillez recharger la page.</p>
          <button onclick="window.location.reload()" style="background: #3b82f6; color: white; padding: 12px 24px; border-radius: 8px; border: none; cursor: pointer; font-size: 16px;">Recharger</button>
          <p style="margin-top: 16px; font-size: 12px; color: #9ca3af;">${error.message}</p>
        </div>
      </div>
    `;
  }
}